import React from 'react'
import AdminRefunds from '../../components/AdminRefunds/AdminRefunds'

export default function AdminRefundPage() {
  return (
        <AdminRefunds/>
    )
}
